import { motion } from "framer-motion";
import { Calendar, Video, Monitor } from "lucide-react";

const CAL_LINK = "https://cal.com/tabletalktv";

const steps = [
  {
    num: "01",
    icon: Calendar,
    title: "Book a 5-minute call",
    desc: "Pick a time. We talk about your business and choose the right diner.",
  },
  {
    num: "02",
    icon: Video,
    title: "We design your 30-second ad",
    desc: "We write, film, and finish your spot. You just approve it.",
  },
  {
    num: "03",
    icon: Monitor,
    title: "Go live on diner TVs this week",
    desc: "Your ad starts playing where local customers already sit and look up.",
  },
];

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.2 } },
};

const item = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const HowItWorks = () => (
  <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white" id="how-it-works">
    <div className="max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <p className="uppercase tracking-[0.2em] text-brand text-xs font-bold mb-3">How It Works</p>
        <h2 className="font-bold text-3xl sm:text-4xl lg:text-5xl text-[var(--color-text)]">
          Easy. Fast. Done.
        </h2>
      </motion.div>

      <motion.div
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="grid md:grid-cols-3 gap-6 lg:gap-8"
      >
        {steps.map((s) => (
          <motion.div
            key={s.num}
            variants={item}
            className="relative group bg-[var(--color-bg)] border border-[var(--color-border)] rounded-2xl p-8 hover:scale-[1.03] hover:shadow-xl transition-all duration-300 overflow-hidden"
          >
            <span className="absolute top-4 right-4 font-bold text-7xl text-[var(--color-text)]/[0.04] select-none pointer-events-none">
              {s.num}
            </span>

            <div className="w-12 h-12 rounded-xl bg-[var(--color-accent)]/10 flex items-center justify-center mb-5">
              <s.icon className="w-6 h-6 text-brand" />
            </div>
            <h3 className="font-bold text-xl mb-3 text-[var(--color-text)]">{s.title}</h3>
            <p className="text-muted-custom text-sm leading-relaxed">{s.desc}</p>
          </motion.div>
        ))}
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mt-12 text-center"
      >
        <p className="text-brand font-bold text-sm mb-4">🔥 Limited Spots Available - Don't Miss Out</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={CAL_LINK}
            className="btn-primary px-8 py-4 text-base"
          >
            <Calendar className="w-5 h-5" />
            Book Your Call Now
          </a>
          <a
            href="tel:+15163433353"
            className="btn-secondary px-8 py-4 text-base"
          >
            Call Now
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);

export default HowItWorks;
